import { Pipe, PipeTransform } from '@angular/core';
import { AssetService } from '../services/asset.service';

@Pipe({
    name: 'asset',
    standalone: true
})
export class AssetPipe implements PipeTransform {

    constructor(private assetService: AssetService) {
    }

    transform(value: string, args?: any): any {
        return this.assetService.getUrl(value);
    }

}
